var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoeShine = function SvgShoeShine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 11.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.551 1.654 8.6 4.1m3.927-1.383L11.6 5.1M.6 1.6v6a3 3 0 0 0 3 3h14.067a2.933 2.933 0 0 0 .986-5.695L6.6.6c0 1-1 2.5-2.5 2.5S1.784 1.876 1.6 1.6z"
  })));
};
export default SvgShoeShine;